import { Typography as AntTypography } from 'antd';
import { Text } from './Text';

export const Typography = {
  Text,
  Title: AntTypography.Title,
  Link: AntTypography.Link,
};
